// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1POCT","dragIcon":"SortableItem_dragIcon__1HaxH","disabled":"SortableItem_disabled__1XUdf"};